import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  mainContent: {
    flex: '1 1 auto',
    overflowX: 'hidden',
    overflowY: 'auto',
    position: 'relative',
    width: '100%',
    zIndex: 1,
    height: 'calc(100vh - 4rem)',
    padding: theme.spacing(3)
  }
}));

export default useStyles;
